import api from "../../config/api";
import LoggerService from "@/services/LoggerService";

const state = {
    searchResponse: {},
    joinOrganizationResponse: {},
    addOrganizationResponse: {},
    addOrgLocationResponse: {}
}
const mutations = {
    SET_SEARCH_RESPONSE(state, payload) {
        state.searchResponse = payload;
    },
    SET_JOIN_ORGANIZATION_RESPONSE(state, payload) {
        state.joinOrganizationResponse = payload;
    },
    SET_ADD_ORGANIZATION_RESPONSE(state, payload) {
        state.addOrganizationResponse = payload;
    },
    SET_ADD_ORGLOCATION_RESPONSE(state, payload) {
        state.addOrgLocationResponse = payload;
    },
}

const actions = {
    async fetchSearchData({ commit }, searchstring) {
        try {
            const response = await api.post("/locationsresource", {
                cmd: "searchbynamepart",
                searchstring: searchstring,
            });
            
            // Process the response data to add locationperson_status based on status field
            let processedData = response.data;
            
            // Handle array response
            if (Array.isArray(processedData)) {
                processedData = processedData.map(location => {
                    // Use status field from API response: "active" = member (1), otherwise not a member (null)
                    const isActive = location.status && String(location.status).toLowerCase() === 'active';
                    return {
                        ...location,
                        locationperson_status: isActive ? 1 : null // 1 = active member, null = not a member
                    };
                });
            } else if (processedData && typeof processedData === 'object' && !Array.isArray(processedData)) {
                // Handle object format if needed
                processedData = Object.keys(processedData).map(key => {
                    const location = processedData[key];
                    const isActive = location.status && String(location.status).toLowerCase() === 'active';
                    return {
                        ...location,
                        locationperson_status: isActive ? 1 : null
                    };
                });
            }
            
            commit('SET_SEARCH_RESPONSE', processedData);
            return processedData;
        } catch (error) {
            console.error('Error fetching search data:', error);
            throw error;
        }
    },

    async addOrganization({ commit }, payload) {
        try {
            const response = await api.post("/homeajax", {
                cmd: "addneworganization",
                ...payload
            });
            commit('SET_ADD_ORGANIZATION_RESPONSE', response.data);
        } catch (error) {
            console.error('Error adding organization:', error);
        }
    },

    async joinOrganization({ commit }, payload) {
        try {
            const response = await api.post("/homeajax", {
                cmd: "joinorganization",
                personid: payload.personid,
                locationid: payload.locationid,
                joinreason: payload.joinreason
            });
            commit('SET_JOIN_ORGANIZATION_RESPONSE', response.data);
        } catch (error) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                "Unknown error";
            LoggerService.logError(
                `[joinOrganization] ${message}`
            );
            console.error('Error joining organization:', error);
        }
    },

    async addOrgLocation({ commit }, payload) {
        try {
            const response = await api.post("/manageorganizationajax", {
                cmd: "addnewlocation",
                ...payload
            });
            commit('SET_ADD_ORGLOCATION_RESPONSE', response.data);
        } catch (error) {
            console.error('Error adding organization location:', error);
        }
    },

}

const getters = {
    stSearchResponse: state => state.searchResponse,
    stJoinOrganizationResponse: state => state.joinOrganizationResponse,
    stAddOrganizationResponse: state => state.addOrganizationResponse,
    stAddOrgLocationResponse: state => state.addOrgLocationResponse,
}

export default {
    state,
    mutations,
    actions,
    getters
}